import { useCallback, useLayoutEffect, useRef } from 'react'

/**
 * A callback whose identity never changes but which always runs the latest
 * `callback`. Pass it to memoized children so a parent re-render (for
 * example on every navigation) doesn't re-render them too. Call it from
 * event handlers, not during render.
 */
export function useStableCallback<Args extends unknown[], Result>(
  callback: (...args: Args) => Result
): (...args: Args) => Result {
  const latestRef = useRef(callback)

  useLayoutEffect(() => {
    latestRef.current = callback
  })

  return useCallback((...args: Args) => latestRef.current(...args), [])
}
